import { Injectable } from '@angular/core';
import { Resolve, } from '@angular/router';
import { VersionsService } from '../services/VersionsService';
import { Versions } from '../models/Versions';

@Injectable()
export class VersionsResolver implements Resolve<Versions> {
	constructor(private versionService: VersionsService) { }

	resolve(): Promise<Versions> {
		return this.versionService.loadVersions();
	}
}

export const VERSIONS_RESOLVER_PROVIDERS = [
	VersionsResolver
];
